module.exports = __webpack_public_path__ + "img/backIndex.9e72f223.png";